import styled from 'styled-components';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const PhoneLink = styled.a<any>`
  text-decoration: none;
  color: black;
`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const HiddenLink = styled(PhoneLink as any)`
  cursor: pointer;
`;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const PhoneBlockWrapper = styled.div<any>`
  margin-left: 30px;
`;
